import { Money } from "classes/DecimalClasses";

import { dateToLocalSosISO, calendarFormat } from "services/utility/dates";
import { isFinishedGoods } from "services/utility/jobWorkCenter";

import globalState from "globalState/globalState";

export function normalizeWorkCenters(workCenters) {
  return workCenters
    .map((workcenter) => ({ workcenter }))
    .filter(({ workcenter: { id } }) => id !== 1);
}

export function normalizeLot(lot) {
  // add id of 0 to each lot object
  // back end requires a zero as the id for new lots
  return lot?.name ? { id: 0, name: lot.name } : null;
}

export function lotSerialNormalizationForFinishedGoods(line, workcenter) {
  const newLine = { ...line };
  if (!isFinishedGoods(workcenter)) {
    newLine.lot = null;
    newLine.serials = null;
  }
  return newLine;
}

export function nonUtcDateTimeHandling(record) {
  const newRecord = { ...record };

  newRecord.date = record.dateChanged
    ? dateToLocalSosISO(record.date)
    : record.originalDate;

  delete newRecord.dateChanged;
  delete newRecord.originalDate;
  return newRecord;
}

// converts Date objects in DATE_FIELDS to "yyyy-MM-dd" strings using
// local time, preventing UTC serialization from shifting the date backward
export function normalizeDateFields(record, dateFields) {
  const newRecord = { ...record };
  dateFields.forEach((field) => {
    if (newRecord[field] instanceof Date) {
      newRecord[field] = calendarFormat(newRecord[field]);
    }
  });
  return newRecord;
}

// although taxAmount is a calculated field (derived from other fields)
// and normally not persisted in the UI, the backend requires this value to be included when saving
// certain records. This is used in v8, generating PDFs, reports, and other downstream processes.
// For that reason, we copy the calculated taxAmount into the record before saving.
export function normalizeTaxAmount(value) {
  const { currencyMinimumFractionDigits } =
    globalState.getState().userCompanySettings.localization;

  return value ? value.round(currencyMinimumFractionDigits) : Money.ZERO();
}
